export const ko = {
    "TRIGGER_LISTEN": "트리거 수신 중",
    "ASSIST_EMPTY_MSG": "AgentAssist는 대화를 주시하고 트리거되면 자동으로 지원할 준비가 되어 있습니다.",
    "MYBOT_TRIGGET_LISTEN": "현재 활성화된 My Bot 작업 없음",
    "MYBOT_EMTPY_MSG": "My Bot에서 작업을 시작하려면 검색 탭으로 이동하여 원하는 작업에 대해 \"에이전트 입력으로 실행\" 옵션을 선택하십시오.",
    "PROACTIVE_MODE": "적극적 모드",
    "SETTINGS": "설정",
    "HELP_AND_SUPPORT": "도움말 및 지원",
    "HELP": "도움말",
    "LANGUAGE": "언어",
    "THEME": "테마",
    "AUTOMATIC": "자동",
    "DARK": "어두운",
    "ASK_A_QUESTION":"질문하기",
    "FILE_NAME":"파일 이름",
    "LIGHT": "빛",
    "AUTOSCROLL_ASSIST":"자동 스크롤 지원",
    "THEME_DESC": "이것은 시스템 기본 모드를 사용합니다.",
    "DOCUMENTATION": "문서",
    "DOC_DESC": "심층 문서 기사를 확인하십시오.",
    "AUTO_SCROLL_TOOLTIP":"도움말 탭, 내 봇 및 대본 탭 콘텐츠의 자동 스크롤을 제어합니다",
    "FAQ_U": "자주 묻는 질문",
    "FAQ_DESC": "AgentAssist에 대한 자주 묻는 질문을 확인하십시오.",
    "KORE_ACADEMY": "코레 아카데미",
    "KORE_ACA_DESC": "아카데미 코스를 통해 AgentAssist에 대해 더 자세히 알아보십시오.",
    "SEARCH": "검색",
    "MY_BOT": "내 봇",
    "ASSIST": "지원",
    "TAB_TEXT":"탭이 활성화되지 않았습니다! 최소한 하나의 탭을 활성화하세요",
    "TRANSCRIPT": "대본",
    "HISTORY": "역사",
    "STARTOVER": "처음부터 다시 시작",
    "RESTART_INPUTS": "캡처된 입력값으로 다시 시작",
    "TAP_SEARCH":"검색하려면 탭하세요",
    "ASKCUSTOMER": "고객에게 묻기",
    "TELLCUSTOMER": "고객에게 말하기",
    "WELCOME_MSG": "환영 메시지",
    "SEND": "보내기",
    "SENT": "전송 됨",
    "AWAITING": "응답 대기 중 | 계속하려면 입력하십시오",
    "OVERRIDE": "계속하려면 입력하십시오",
    "ACCEPT_RESPONSE": "응답 수락",
    "AGENT_ENTERED": "에이전트가 입력했습니다",
    "EXPECTED_FORMAT": "예상 형식",
    "INPUT_VALUES": "입력 값",
    "RESTART": "다시 시작",
    "START_OVER": "처음부터 다시 시작",
    "RESTART_CAPTURE": "캡처된 입력으로 다시 시작",
    "CANCEL": "취소",
    "INTERRUPT_DIALOG": "대화 작업 중단",
    "RUN": "실행",
    "RUN_AGENT": "에이전트 입력으로 실행",
    "STEP": "단계",
    "DIALOG_TASK": "대화 작업",
    "FAQ": "자주 묻는 질문",
    "SNIPPET": "답변",
    "ARTICLE": "웹 페이지",
    "FILE": "파일",
    "SUGGESTED": "제안된",
    "ALL_DIALOG": "모든 대화 작업",
    "DIALOG_TEXT": "대화",
    "INTENT_IDENTIFIED": "고객 발화",
    "NOT_WHAT_LOOKING": "잘못된 제안?",
    "BOT": "봇",
    "CUSTOMER": "고객",
    "YOU": "당신",
    "TERMINATE_CONV": "대화 작업 종료",
    "TERMINATE_CONV_DESC": "대화 작업을 종료하시겠습니까? AgentAssist는 더 이상 제안을 생성할 수 없습니다.",
    "YES_TERMINATE": "예, 종료",
    "NO_CANCEL": "아니요, 취소",
    "OVERRIDE_CONTINUE": "오버라이드 모드로 계속",
    "SUMMARY_TEXT": "요약",
    "SUBMIT": "제출",
    "INTERRUPT_OCCURED": "중단 발생",
    "IDENTIFIED_INTENT": "확인된 의도",
    "INTERRUPT_DESC": "이 작업을 실행하면 현재 진행 중인 대화 작업이 종료됩니다.",
    "ACCEPT_RUN": "수락하고 실행",
    "RUN_LATER": "나중에 실행",
    "KNOW_MORE": "더 알아보기",
    "MORE_TEXT": "더",
    "LESS_TEXT": "덜",
    "VIEW_MORE": "더보기",
    "VIEW_LESS": "적게 보기",
    "SHOW_MORE_FAQ": "더 많은 FAQ 표시",
    "SHOW_LESS_FAQ": "적은 FAQ 표시",
    "SHOW_MORE_ARTICLE": "더 많은 웹 페이지 표시",
    "SHOW_LESS_ARTICLE": "적은 웹 페이지 표시",
    "SHOW_MORE_SNIPPET": "더 많은 답변 표시",
    "SHOW_LESS_SNIPPET": "적은 답변 표시",
    "SHOW_MORE_FILES": "더 많은 파일 표시",
    "SHOW_LESS_FILES": "적은 파일 표시",
    "VIEW_ALL_DIALOG": "모든 대화 보기",
    "VIEW_FEW_DIALOG": "몇 가지 대화만 보기",
    "HELP_FULL": "도움이 되었습니까?",
    "THANKYOU": "감사합니다!",
    "EXPAND_MORE": "확장 \/ 더보기",
    "CLOSE_TEXT": "닫기",
    "STARTED": "시작됨",
    "ENDED": "종료됨",
    "VIEW_FULL_ARTICLE": "전체 웹 페이지 보기",
    "VIEW_FULL_FILE": "전체 파일 보기",
    "COPIED": "복사됨",
    "SENTI_ANALY": "감정 분석",
    "WRONG_SUGGESTION": "잘못된 제안",
    "INCORRECT_INTENT": "부정확한 의도",
    "ACCIDENTAL_CLICK": "우발적인 클릭",
    "TIME_TAKING": "시간이 걸림",
    "OTHER": "다른",
    "PLAYBOOK_EMPTY_MSG": "플레이북 선택",
    "PLAYBOOK_EMPTY_DESC": "AgentAssist는 사용 가능한 모든 플레이북이 동적이기 때문에 플레이북을로드할 수 없습니다. '플레이북 선택'을 클릭하여 플레이북에 액세스하십시오",
    "STAGE": "스테이지",
    "PROCEED_TO_CLOSE": "닫기로 이동하려면 닫기 버튼을 클릭하십시오",
    "RECOMENDED_PLAYBOOK": "추천 플레이북",
    "PRIMARY_SCRIPTS": "기본 스크립트",
    "DYNAMIC_SCRIPTS": "동적 스크립트",
    "RESUME": "이어서",
    "ENABLE_CLOSE": "닫기 스테이지를 활성화하려면 '닫기로 진행' 버튼을 클릭하십시오",
    "LIST_VIEW": "목록 보기",
    "TERMINATE": "종료",
    "MINIMIZE": "최소화",
    "MAXIMIZE": "최대화",
    "NO_SEARCH_RESULT": "검색 결과 없음",
    "SENTIMENT_AWAITING": "감정 대기 중",
    "POSITIVE": "긍정적",
    "NEGATIVE": "부정적",
    "COPY" : "복사",
    "TELL_US_MORE": "자세히 알려주세요",
    "THANKS_FEEDBACK": "피드백 감사합니다",
    "SOMETHING_WRONG": "문제가 발생했습니다",
    "CLICK_ERROR_DETAILS": "오류 세부정보를 보려면 클릭하세요",
    "NO_ACTIVE_PLAYBOOK": "활성 플레이북이 없습니다",
    "PLAYBOOK": "플레이북",
    "REPHRASE_QUESTION": "질문을 다시 표현하거나 다른 것을 물어보시겠습니까?",
    "INTERNAL_INFO": "내부 정보",
    "SOURCES": "출처",
    "CONVERSATION_SUMMARY": "대화 요약",
    "WAITING": "대기 중",
    "WIDGET_DISABLED": "위젯이 비활성화되었습니다",
    "AI_SETTINGS_DISABLED": "AI 설정이 비활성화되었습니다! AI 관리자에게 문의하세요",
    "SERVER_CONNECTION_ERROR": "서버 연결 중 오류 발생",
    "VIEW": "보기",
    "ATTACHMENT_INPUT": "첨부 파일 입력",
    "TYPE_SUMMARY": "요약 입력",
    "VIEW_FULL_ARTICLE_2": "전체 기사를 보려면",
    "VIEW_FULL_FILE_2": "전체 파일 보려면",
    "BY":"에 의해",
    GENERATE_SUMMARY: "요약 생성",
    PREV_SUMMARIES: "이전에 생성된 요약",
    DIALOG_WORKFLOWS: "대화 워크플로",
    SHOW_ALL_DIALOG: "모든 대화 작업 표시",
    SHOW_ALL_DIALOGS: "모든 대화 표시",
    CUSTOM_TAB: "사용자 정의 탭",
    AGENT_INPUT: "에이전트 입력",
    "CUSTOM_EMPTY_MSG" : "현재 활성 워크플로우가 없습니다",
    "CUSTOM_TAB_DESC" : "워크플로우를 시작하려면 화면 하단에 있는 목록에서 하나를 실행하세요.",
    "SUBMIT_OVERALL_FEEDBACK" : "전체 피드백 제출",
    "FEEDBACK_POPUP_SUBTITLE" : "위젯과 그 기능에 대한 피드백",
    "FEEDBACK_SATISFIED" : "만족",
    "FEEDBACK_UNSATISFIED" : "만족하지 않음",
    "FEEDBACK_PROVIDE_REASONS" : "더 많은 정보를 제공…",
    "FEEDBACK_TITLE" : "피드백",
    "AGENTIC_THINKING" : "생각 중",
    "AGENTIC_AGENT_TITLE" : "에이전트",
    "AGENTIC_COPILOT_MODE_TITLE" : "에이전트 코파일럿 모드",
    "AGENTIC_SENDING_MESSAGE" : "전송 중...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot이 대화를 적극적으로 듣고 있으며 자동으로 지원할 준비가 되어 있습니다",
    "AGENTIC_SEARCH_RESULTS" : "에이전트 결과"
}